import React, { useEffect } from "react";

const FrfrUtilsCbWhenMounted = (props) => {
  console.log('FrfrUtilsCbWhenMounted');
  const { componentDidMount } = props;
  const something_unchanged = null;
  useEffect(() => { // componentDidMount
    // auto cb
    if (typeof componentDidMount === 'function') {
      console.log('FrfrUtilsCbWhenMounted componentDidMount WITH CALLBACK');
      componentDidMount();
    } else {
      console.log('FrfrUtilsCbWhenMounted componentDidMount WITHOUT callback');
    }
  }, []);
  return (<></>);
};

export default FrfrUtilsCbWhenMounted;